import type { Theme } from "@mui/material"
import { GlobalNavigationItemTheme } from "core/themes/src/definitions/components.types"

export const createGlobalNavigationItemTheme = (theme: Theme): GlobalNavigationItemTheme => ({
    styleOverrides: {
        icon: {
            fill: "rgba(250, 250, 250, 0.87)",
            "&.icon-feedback-alternative": {
                height: "26px",
                width: "26px",
            },
            "&.icon-user": {
                width: "21px",
                height: "21px",
                margin: "2px",
            },
        },
    },
})
